export const PUBLIC_LOCALES = ['ar', 'en']
export const DEFAULT_PUBLIC_LOCALE = 'ar'

export function localizePath(path, lang) {
  const value = String(path || '/')

  if (/^https?:\/\//i.test(value)) return value

  const normalizedPath = value.startsWith('/') ? value : `/${value}`
  const locale = PUBLIC_LOCALES.includes(lang)
    ? lang
    : DEFAULT_PUBLIC_LOCALE

  if (normalizedPath === '/') return `/${locale}`

  return `/${locale}${normalizedPath}`
}